/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharedplan_ImportInputs */

const en_us2_sharedplan_import = /** @type {(inputs: Sharedplan_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review and import`)
};

const pt_br2_sharedplan_import = /** @type {(inputs: Sharedplan_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar e importar`)
};

const pt_pt2_sharedplan_import = /** @type {(inputs: Sharedplan_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar e importar`)
};

/** @type {(inputs: Sharedplan_ImportInputs) => LocalizedString} */
const es_419_sharedplan_import = en_us2_sharedplan_import;

/** @type {(inputs: Sharedplan_ImportInputs) => LocalizedString} */
const fr_fr2_sharedplan_import = en_us2_sharedplan_import;

/** @type {(inputs: Sharedplan_ImportInputs) => LocalizedString} */
const de_de2_sharedplan_import = en_us2_sharedplan_import;

/** @type {(inputs: Sharedplan_ImportInputs) => LocalizedString} */
const it_it2_sharedplan_import = en_us2_sharedplan_import;

/**
* | output |
* | --- |
* | "Review and import" |
*
* @param {Sharedplan_ImportInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const sharedplan_import = /** @type {((inputs?: Sharedplan_ImportInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharedplan_ImportInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_sharedplan_import(inputs)
	if (locale === "es-419") return es_419_sharedplan_import(inputs)
	if (locale === "pt-PT") return pt_pt2_sharedplan_import(inputs)
	if (locale === "fr-FR") return fr_fr2_sharedplan_import(inputs)
	if (locale === "de-DE") return de_de2_sharedplan_import(inputs)
	if (locale === "it-IT") return it_it2_sharedplan_import(inputs)
	return en_us2_sharedplan_import(inputs)
});
export { sharedplan_import as "sharedplan.import" }